import { createPortal } from "react-dom";

import { DASHBOARD_LAYOUT_CONTENT_ID } from "./DashboardLayout.constants";

export const renderInDashboardLayoutContent = (children: React.ReactNode) => {
  const container = document.getElementById(DASHBOARD_LAYOUT_CONTENT_ID);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
